<script setup lang="ts">
withDefaults(defineProps<{ size?: number }>(), { size: 20 })
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18 10a8 8 0 1 0-9.25 7.903V12.89H6.9V10h1.85V8.108c0-1.827 1.088-2.837 2.754-2.837.798 0 1.633.143 1.633.143v1.794h-.92c-.906 0-1.19.562-1.19 1.138V10h2.023l-.323 2.89H11.03v5.013A8.001 8.001 0 0 0 18 10Z" />
  </svg>
</template>
